// extracted by mini-css-extract-plugin
export default {"defaultKindRadius":"aNcRA","containerKindRadius":"bNcRA","cardKindRadius":"cNcRA","iconKindRadius":"dNcRA","responsive":"eNcRA"};